import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import { faSignInAlt, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./CreateUser.module.scss";
import Button from "../../../UI/Button/Button";
import ErrorPanel, { ErrorSize } from "../../../UI/ErrorPanel/ErrorPanel";

import * as SandBoxAdminActions from "../../../../middleware/Store/Actions/SandBoxAdminActions";
import * as UserUtils from "../../../Utils/UserUtils";
import * as ErrorUtils from "../../../Utils/ErrorUtils";

import LogService from "../../../../middleware/CommonSdk/LogService";
const LOG_TAG = "CREATE_USER";

/* !! Design Deprecated*/

const CreateUser = (props) => {
    const intl = useIntl();
    const [loginEmail, setLoginEmail] = useState("");
    const [password, setPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [displayClearPassword, setDisplayClearPassword] = useState(false);

    const [errorMessage, setErrorMessage] = useState("");
    const [progress, setProgress] = useState(false);

    const handleEmailChange = (event) => {
        setLoginEmail(event.target.value);
    }

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    }

    const handleFirstNameChange = (event) => {
        setFirstName(event.target.value);
    }

    const handleLastNameChange = (event) => {
        setLastName(event.target.value);
    }

    const handleCreateUser = () => {
        LogService.trace(LOG_TAG, "handleCreateUser");

        setProgress(true);
        const userData = {
            email: loginEmail,
            password: password,
            firstName: firstName,
            lastName: lastName
        }
        props.createUser(userData)
            .then((user) => {
                LogService.trace(LOG_TAG, "handleEmailChange success", user);
                setErrorMessage("");
                setProgress(false);

                if (props.onActionSuccess)
                    props.onActionSuccess();
            })
            .catch((errorPayload) => {
                LogService.error(LOG_TAG, "handleEmailChange error");
                const errorMessage = ErrorUtils.getPrettyErrorMessage(errorPayload, intl);
                setErrorMessage(errorMessage);
                setProgress(false);

                if (props.onActionFailed)
                    props.onActionFailed();
            });
    }

    LogService.trace(LOG_TAG, "render");
    const isValidEmail = UserUtils.isValidEmail(loginEmail);
    const isValidPassword = UserUtils.isValidPassword(password);

    const enableButton = isValidEmail && isValidPassword && firstName.length > 0 && lastName.length > 0;

    return (
        <div>
            {props.message &&
                <div className={styles.body}>
                    <p className={styles.subtitle}>{props.message}</p>
                </div>
            }
            <form className={styles.form}>
                <label id="createUser_emailLabel" className="input-label" htmlFor="email">{intl.messages.loginEmail}</label>
                <div className="input-group mb-3">
                    <input
                        id="email"
                        type="email"
                        className={!isValidEmail ? "form-control is-invalid" : "form-control "}
                        placeholder={props.emailPlaceholder}
                        autoComplete="true"
                        onChange={handleEmailChange}
                    />
                </div>

                <label id="createUser_passwordLabel" className="input-label" htmlFor="password">{intl.messages.loginPwd}</label>
                <div className="input-group mb-3">
                    <input
                        id="password"
                        type={displayClearPassword ? "text" : "password"}
                        className={!isValidPassword ? "form-control is-invalid" : "form-control "}
                        placeholder={intl.messages.loginPwdPlaceHolder}
                        autoComplete="true"
                        onChange={handlePasswordChange}
                    />
                    <div className="input-group-append">
                        <button className="btn input-btn" type="button" onClick={() => setDisplayClearPassword(!displayClearPassword)}>
                            <FontAwesomeIcon icon={displayClearPassword ? faEyeSlash : faEye} />
                        </button>
                    </div>
                </div>

                <label id="createUser_lastName" className="input-label" htmlFor="lastName">{intl.messages.sandBoxProfileCreateUserLastNameTitle}</label>
                <div className="input-group mb-3">
                    <input
                        id="lastName"
                        className="form-control"
                        placeholder={props.sandBoxProfileCreateUserLastNamePlaceholder}
                        autoComplete="true"
                        onChange={handleLastNameChange}
                    />
                </div>

                <label id="createUser_firstName" className="input-label" htmlFor="firstName">{intl.messages.sandBoxProfileCreateUserFirstNameTitle}</label>
                <div className="input-group mb-3">
                    <input
                        id="firstName"
                        className="form-control"
                        placeholder={props.sandBoxProfileCreateUserFirstNamePlaceholder}
                        autoComplete="true"
                        onChange={handleFirstNameChange}
                    />
                </div>

                <div className="mt-3">
                    <Button
                        label={intl.messages.create}
                        icon={faSignInAlt}
                        onClick={handleCreateUser}
                        spinner={progress}
                        disabled={!enableButton}
                    />
                    {(errorMessage) &&
                        <div>
                            <ErrorPanel size={ErrorSize.Small} >{errorMessage}</ErrorPanel>
                        </div>
                    }
                </div>
            </form>
        </div>
    );

}

CreateUser.defaultProps = {
    message: "",
    emailPlaceholder: "",
    isSandBox: true,
    onActionSuccess: null,
    onActionFailed: null
}

CreateUser.propTypes = {
    message: PropTypes.string,
    emailPlaceholder: PropTypes.string,
    isSandBox: PropTypes.bool,
    onActionSuccess: PropTypes.func,
    onActionFailed: PropTypes.func
};


const mapDispatchToProps = (dispatch, props) => {
    return {
        createUser: (userData) => dispatch(SandBoxAdminActions.createSandBoxUser(userData)),
    }
}

export default connect(null, mapDispatchToProps)(CreateUser);
